import { useTheme } from "@emotion/react";
import React from "react";
import { Stroke3 } from "../../icons";
import classNames from "classnames";
import { opacity } from "../../utils/color";
import styles from "./Switch.module.scss";
import { Loading } from "../progress";
export const Switch = (props) => {
    const theme = useTheme();
    const clickHandler = (event) => {
        var _a;
        if (props.stopPropagation) {
            event.stopPropagation();
        }
        if (!props.disabled)
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, !props.checked);
    };
    const icon = props.loading ? (React.createElement(Loading, { size: 16 })) : (React.createElement(Stroke3, { size: 10, color: props.disabled
            ? opacity(theme.colors.ripple, 0.15)
            : theme.colors.primary[50] }));
    return (React.createElement("div", { className: classNames(styles.Switch, {
            [styles.Checked]: props.checked,
            [styles.Disabled]: props.disabled,
            [styles.Loading]: props.loading,
        }), onClick: clickHandler, "data-testid": props["data-testid"] },
        React.createElement("div", { className: styles.Circle }, icon)));
};
//# sourceMappingURL=Switch.js.map